require("jquery-ui/ui/widgets/datepicker");
require("jquery-ui/ui/widgets/dialog");

var SSN = "";
var DUNS = "";
var formID;
var companyID;
var key;
var docCount = 0;
var companyInfoSaved = false;
Dropzone.autoDiscover = false;

//test phone JS
//https://github.com/jackocnr/intl-tel-input

let phoneIti = null;
let mailingPhoneIti = null;
let mailingTollFreeIti = null;
let mailingFaxIti = null;
let mailingContactPhoneIti = null;
let remitPhoneIti = null;
let remitTollFreeIti = null;
let remitFaxIti = null;
let remitContactPhoneIti = null;

$(function () {
    phoneIti = setupPhoneInput("phone");

    mailingPhoneIti = setupPhoneInput("mailingPhone");
    mailingTollFreeIti = setupPhoneInput("mailingTollFree");
    mailingFaxIti = setupPhoneInput("mailingFax");
    mailingContactPhoneIti = setupPhoneInput("mailingContactPhone");
    remitPhoneIti = setupPhoneInput("remitPhone");
    remitTollFreeIti = setupPhoneInput("remitTollFree");
    remitFaxIti = setupPhoneInput("remitFax");
    remitContactPhoneIti = setupPhoneInput("remitContactPhone");

    var test = document.querySelector('#phone');

    test.addEventListener('countrychange', function (e) {


        var countryData = phoneIti.getSelectedCountryData();
        isoCode = countryData.iso2;
        console.log(isoCode);
        mailingPhoneIti.setCountry(isoCode);
        mailingTollFreeIti.setCountry(isoCode);
        mailingFaxIti.setCountry(isoCode);
        mailingContactPhoneIti.setCountry(isoCode);
        remitPhoneIti.setCountry(isoCode);
        remitTollFreeIti.setCountry(isoCode);
        remitFaxIti.setCountry(isoCode);
        remitContactPhoneIti.setCountry(isoCode);
    });
});

function setupPhoneInput(elemID) {

    var telInput = document.querySelector("#" + elemID);
    var telInputjQuery = $("#" + elemID);

    var errorMsg = $("#error-msg" + elemID);
    var validMsg = $("#valid-msg" + elemID);


    var outputValue = window.intlTelInput(telInput, {
        allowDropdown: true,
        autoHideDialCode: true,
        autoPlaceholder: "off",
        dropdownContainer: "",
        excludeCountries: [],
        formatOnInit: true,
        geoIpLookup: function (callback) {
            $.get("http://ipinfo.io", function () { }, "jsonp").always(function (resp) {
                var countryCode = (resp && resp.country) ? resp.country : "";
                callback(countryCode);
            });
        },
        //hiddenInput: true,
        initialCountry: "us",
        nationalMode: false,
        numberType: "FIXED_LINE",
        onlyCountries: [],
        preferredCountries: [],
        separateDialCode: true,
        utilsScript: "static/generated/utils.min.js"
    });

    telInputjQuery.on("keyup", function (e) {
        $(this).prop("value", function (i, o) {
            var input = o.replace(/[^0-9]/, "");
            var keyCode = e.code;
            if ((keyCode < 47) || (keyCode > 58)) {
                return o.replace(/\D/g, "");
            }
        });
    });

    var reset = function () {
        telInputjQuery.removeClass("error");
        errorMsg.addClass("hidden");
        validMsg.addClass("hidden");
    };

    // on blur: validate
    telInputjQuery.on("blur", function () {
        reset();
        // if (telInput.val().trim()) {
        if (outputValue.isValidNumber()) {
            validMsg.removeClass("hidden");
        } else {
            telInputjQuery.addClass("error");
            errorMsg.removeClass("hidden");
        }
        //  }
    });

    telInputjQuery.on("keyup change", reset);

    return outputValue;
}


function parsePhoneData(teleInputObject) {
    returnPhoneObject = new Object();
    returnPhoneObject.phoneNum = teleInputObject.getNumber();
    returnPhoneObject.countryData = teleInputObject.getSelectedCountryData();
    returnPhoneObject.dialCode = returnPhoneObject.countryData.dialCode;
    returnPhoneObject.areaCode = "";
    if (returnPhoneObject.countryData.iso2 === "us") {
        returnPhoneObject.areaCode = returnPhoneObject.phoneNum.substring(returnPhoneObject.dialCode.length + 1, returnPhoneObject.dialCode.length + 4);
        returnPhoneObject.phoneNum = returnPhoneObject.phoneNum.substring(returnPhoneObject.dialCode.length + 4, returnPhoneObject.phoneNum.length);
    }
    else {
        returnPhoneObject.phoneNum = returnPhoneObject.phoneNum.substring(returnPhoneObject.dialCode.length + 1, returnPhoneObject.phoneNum.length);
    }

    return returnPhoneObject;
}

function doDocCount(addRemove) {
    if (addRemove === '+') {
        docCount = docCount + 1;
    }
    else {
        if (docCount > 0) {
            docCount = docCount - 1;
        }
    }

    if (docCount > 0) {
        $('#docTable').removeClass('hidden');
    }
    else {
        $('#docTable').addClass('hidden');
    }
};

$(function () {
    $('#taxIDType').on('change', function () {
        if ($('#taxIDType').val() === 'Foreign') {
            $('#taxIdTr').hide();
            $('#TaxIDInput').val('999999999');
        }
        else {
            $('#taxIdTr').show();
            $('#TaxIDInput').val('');
        }
    });
});

$(function () {
    $('#supplierGroup').on('change', function () {
        if ($('#selectedSupplierGroups').children('option').length < 5) {
            $('#supplierGroup option:selected').remove().appendTo('#selectedSupplierGroups');
        }
    });
});

$(function () {
    $('#selectedSupplierGroups').on('change', function () {
        $('#selectedSupplierGroups option:selected').remove().appendTo('#supplierGroup');
    });
});

$(function () {
    Dropzone.options.myDropzone = {
        init: function () {
            this.on("processing", function (file) {
                this.options.url = `applets/upload.php?ID=${companyID}&formID=${formID}&key=${key}`;
            })
            this.on("error", function (file, responseText) {
                var msg = responseText;
                return false;
            })
            this.on("success", function (file, responseText) {
                var msg = responseText;
                doDocCount('+');
                return true;
            });
            
        },

        removedfile: function (file) {
            var name = file.name;
            $.ajax
                ({
                    type: 'POST',
                    url: `applets/removefile.php?ID=${companyID}&Name=${name}`,
                    data: `ID=${companyID}&Name=${name}`,
                    dataType: 'html',
                    success: function (data) {
                        doDocCount('-');

                        var _ref;
                        return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
                    },
                    error: function (data) {
                        var output;

                        for (var entry in data) {
                            if (entry == 'responseText') {
                                output = data[entry];
                            }
                        }

                        showMessageBox(output, 'Error', 'error');
                        return false;
                    }
                });
        },
        acceptedFiles: "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg",
        dictDefaultMessage: "To upload, drag and drop files or click this box to browse desktop. <strong>Please note that only JPG, PDF, or Word Documents are allowed.</strong>",
        maxFileSize: 5,
        withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 5,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: 5,
      addRemoveLinks: true,
      dictDefaultMessage: "To upload, drag and drop files or click this box to browse desktop. <u><b>Please note that only JPG, PDF, or Word Documents are allowed.</b></u>",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files."
    };

    Dropzone.discover();
});

$(function () {
    $('#submitVendorDocuments').on('click', function () {
        if (docCount > 0) {
            $.ajax({
                url: 'applets/saveTaxDocumentDate.php',
                method: 'POST',
                data: {
                    input: JSON.stringify({
                        "companyID": companyID,
                        "taxDocumentDate": $('#TaxDocumentDate').val()
                    })
                },
                dataType: "JSON",
                success: function (data) {
                    if (data == null) {
                        var output_msg = "An invalid response was recieved from the HOST.";
                        showMessageBox(output_msg, 'Error saving information', "error");
                        return false;
                    }
                    if (data.error != undefined && data.error.hasOwnProperty('e')) {
                        var output_msg = data.error.error;
                        showMessageBox(output_msg, 'Error saving information', "error");
                        return false;
                    }
                    if (data.success == undefined) {
                        var output_msg = 'An invalid response was recieved from the HOST.';
                        showMessageBox(output_msg, 'Error saving information', "error");
                        return false;
                    }
                    else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                        reloadFinalVerificationPage();
                        hideStep6('#submitVendorDocuments');
                        showStep7();
                        return true;
                    }
                    else {
                        var output_msg = data.error.error;
                        showMessageBox(output_msg, 'Error', 'error');
                        return false;
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (xhr.status == 404 || thrownError == 'Not Found') {
                        var output_msg = thrownError;
                        showMessageBox(output_msg, 'Error saving information', "error");
                        return false;
                    }
                    else {
                        var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                        showMessageBox(output_msg, 'Error saving information', "error");
                        return false;
                    }
                }
            });

        }
        else {
            showMessageBox('Please Upload a Tax Document', 'Tax Document Required', "error");
        }
    });
});

$(function () {
    $("#TaxDocumentDate").datepicker();
});

$(function () {
    $('#FinalVerification').on('click', '#editCompanyInfoButton', function () {
        hideStep7();
        showStep1("#saveCompanyInfoEditButton");
    });
});

$(function () {
    $('#FinalVerification').on('click', '#editMailingInfo', function () {
        hideStep7();
        showStep2("#saveLocationContactInfoEditButton");
    });
});

$(function () {
    $('#FinalVerification').on('click', '#editRemitInfo', function () {
        hideStep7();
        showStep3("#saveRemitInfoEditButton");
    });
});

$(function () {
    $('#FinalVerification').on('click', '#editPaymentOption', function () {
        hideStep7();
        showStep4("#saveSupplierPaymentOptionsEditButton");
    });
});

$(function () {
    $('#FinalVerification').on('click', '#editRelationship', function () {
        hideStep7();
        showStep4("#saveSupplierPaymentOptionsEditButton");
    });
});

$(function () {
    $('#FinalVerification').on('click', '#editSupplierGroups', function () {
        hideStep7();
        showStep5("#saveBusinessCategoryEditButton");
    });
});

$(function () {
    $('#mainPhoneCountryQuestion').on('click', function () {
        $('#mainPhoneCountryQuestion').addClass("hidden");
        $('#mainPhoneCountry').removeClass('hidden');
    });
});

$(function () {
    $('#mainPhoneCountry').on('click change', function () {
        $('#internationalCode').html('+' + $('#mainPhoneCountry').val());
    });
});

$(function () {
    $('#mailingTollFreeCountryQuestion').on('click', function () {
        $('#mailingTollFreeCountryQuestion').addClass("hidden");
        $('#mailingTollFreeInternationalCode').removeClass('hidden');
    });
});

$(function () {
    $('#mailingPhoneCountryQuestion').on('click', function () {
        $('#mailingPhoneCountryQuestion').addClass("hidden");
        $('#mailingPhoneInternationalCode').removeClass('hidden');
    });
});

$(function () {
    $('#mailingFaxCountryQuestion').on('click', function () {
        $('#mailingFaxCountryQuestion').addClass("hidden");
        $('#mailingFaxInternationalCode').removeClass('hidden');
    });
});

$(function () {
    $('#mailingContactCountryQuestion').on('click', function () {
        $('#mailingContactCountryQuestion').addClass("hidden");
        $('#mailingContactInternationalCode').removeClass('hidden');
    });
});

$(function () {
    $('#remitPhoneCountryQuestion').on('click', function () {
        $('#remitPhoneCountryQuestion').addClass("hidden");
        $('#remitPhoneInternationalCode').removeClass('hidden');
    });
});

$(function () {
    $('#remitTollFreeCountryQuestion').on('click', function () {
        $('#remitTollFreeCountryQuestion').addClass("hidden");
        $('#remitTollFreeInternationalCode').removeClass('hidden');
    });
});

$(function () {
    $('#remitFaxCountryQuestion').on('click', function () {
        $('#remitFaxCountryQuestion').addClass("hidden");
        $('#remitFaxInternationalCode').removeClass('hidden');
    });
});

$(function () {
    $('#remitContactCountryQuestion').on('click', function () {
        $('#remitContactCountryQuestion').addClass("hidden");
        $('#remitContactInternationalCode').removeClass('hidden');
    });
});

$(function () {
    $('#saveCompanyInfo').on('click', function () {
        var minorityOwnedBusiness = $("#minorityOwnedBusiness").is(":checked");
        var womanOwnedBusiness = $("#womanOwnedBusiness").is(":checked");
        var disadvantaged = $("#disadvantaged").is(":checked");
        var disabilityOwnedBusiness = $("#disabilityOwnedBusiness").is(":checked");
        var lgbtOwned = $("#lgbtOwned").is(":checked");
        var vetOwnedEnterprise = $("#vetOwnedEnterprise").is(":checked");
        var smallBusiness = $("#smallBusiness").is(":checked");

        var d = new Date().toISOString().slice(0, 19).replace('T', ' ');
        formID = $("#CompanyNameInput").val().replace(/[^A-Za-z0-9\s:-]/g, '').substring(0, 30) + d;

        var phoneNum = phoneIti.getNumber();
        var countryData = phoneIti.getSelectedCountryData();
        var dialCode = countryData.dialCode;
        var areaCode = "";
        if (countryData.iso2 === "us") {
            areaCode = phoneNum.substring(dialCode.length + 1, dialCode.length + 4);
            phoneNum = phoneNum.substring(dialCode.length + 4, phoneNum.length);
        }
        else {
            phoneNum = phoneNum.substring(dialCode.length + 1, phoneNum.length);
        }

        $.ajax({
            url: 'applets/saveCompanyInfoToTable.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "companyName": $("#CompanyNameInput").val(),
                    "DBAName": $("#DBANameInput").val(),
                    "businessURL": $("#BusinessURLInput").val(),
                    "taxIDType": $("#taxIDType").val(),
                    "taxID": $('#TaxIDInput').val(),
                    "duns": $('#DUNSInput').val(),
                    "submittedByName": `${$("#PrimaryContactFirstNameInput").val()} ${$("#PrimaryContactMiddleNameInput").val()} ${$("#PrimaryContactLastNameInput").val()}`,
                    "submittedByFirstName": $("#PrimaryContactFirstNameInput").val(),
                    "submittedByMiddleName": $("#PrimaryContactMiddleNameInput").val(),
                    "submittedByLastName": $("#PrimaryContactLastNameInput").val(),
                    "submittedByPhoneCountry": countryData.iso2,
                    "submittedByInternationalCode": dialCode,
                    "submittedByAreaCode": areaCode,
                    "submittedByPhone": phoneNum,
                    "submittedByPhoneExt": $("#PhoneExtInput").val(),
                    "submittedByTitle": $("#PrimaryContactTitleInput").val(),
                    "submittedByEmail": $("#EmailInput").val(),
                    "organizationType": $("input[name=businessType]:checked").val(),
                    "backupWithHolding": $("input[name=backupWithHolding]:checked").val(),
                    "usPerson": $("input[name=usPerson]:checked").val(),
                    "correctFEIN": $("input[name=correctFEIN]:checked").val(),
                    "formID": formID,
                    "minorityOwnedBusiness": minorityOwnedBusiness,
                    "womanOwnedBusiness": womanOwnedBusiness,
                    "disadvantaged": disadvantaged,
                    "disabilityOwnedBusiness": disabilityOwnedBusiness,
                    "lgbtOwned": lgbtOwned,
                    "vetOwnedEnterprise": vetOwnedEnterprise,
                    "smallBusiness": smallBusiness,
                    "departmentName": $("#DepartmentNameInput").val(),
                    "departmentContact": $("#DepartmentContactInput").val(),
                    "queryType": "insert"
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;
                    companyID = data.success.companyID;
                    key = data.success.key;
                    companyInfoSaved = true;
                    showMessageBox(output_msg, 'Success', 'success');
                    hideStep1("#saveCompanyInfo");
                    showStep2();
                    $('#companyP').html(`<p><b>Company Name: ${$("#CompanyNameInput").val()}</b></p><p><b>DBA Name: ${$("#DBANameInput").val()}</b></p>`);
                    $('#showThroughOut').removeClass("hidden");
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //alert(data);
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                //return false;
            }
        });
    });
});

$(function () {
    $('#saveCompanyInfoEditButton').on('click', function () {
        var minorityOwnedBusiness = $("#minorityOwnedBusiness").is(":checked");
        var womanOwnedBusiness = $("#womanOwnedBusiness").is(":checked");
        var disadvantaged = $("#disadvantaged").is(":checked");
        var disabilityOwnedBusiness = $("#disabilityOwnedBusiness").is(":checked");
        var lgbtOwned = $("#lgbtOwned").is(":checked");
        var vetOwnedEnterprise = $("#vetOwnedEnterprise").is(":checked");
        var smallBusiness = $("#smallBusiness").is(":checked");

        var phoneNum = phoneIti.getNumber();
        var countryData = phoneIti.getSelectedCountryData();
        var dialCode = countryData.dialCode;
        var areaCode = "";
        if (countryData.iso2 === "us") {
            areaCode = phoneNum.substring(dialCode.length + 1, dialCode.length + 4);
            phoneNum = phoneNum.substring(dialCode.length + 4, phoneNum.length);
        }
        else {
            phoneNum = phoneNum.substring(dialCode.length + 1, phoneNum.length);
        }
        $.ajax({
            url: 'applets/saveCompanyInfoToTable.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "companyName": $("#CompanyNameInput").val(),
                    "DBAName": $("#DBANameInput").val(),
                    "businessURL": $("#BusinessURLInput").val(),
                    "taxIDType": $("#taxIDType").val(),
                    "taxID": $('#TaxIDInput').val(),
                    "duns": $('#DUNSInput').val(),
                    "submittedByName": `${$("#PrimaryContactFirstNameInput").val()} ${$("#PrimaryContactMiddleNameInput").val()} ${$("#PrimaryContactLastNameInput").val()}`,
                    "submittedByFirstName": $("#PrimaryContactFirstNameInput").val(),
                    "submittedByMiddleName": $("#PrimaryContactMiddleNameInput").val(),
                    "submittedByLastName": $("#PrimaryContactLastNameInput").val(),
                    "submittedByPhoneCountry": countryData.iso2,
                    "submittedByInternationalCode": dialCode,
                    "submittedByAreaCode": areaCode,
                    "submittedByPhone": phoneNum,
                    "submittedByPhoneExt": $("#PhoneExtInput").val(),
                    "submittedByTitle": $("#PrimaryContactTitleInput").val(),
                    "submittedByEmail": $("#EmailInput").val(),
                    "organizationType": $("input[name=businessType]:checked").val(),
                    "backupWithHolding": $("input[name=backupWithHolding]:checked").val(),
                    "usPerson": $("input[name=usPerson]:checked").val(),
                    "correctFEIN": $("input[name=correctFEIN]:checked").val(),
                    "formID": formID,
                    "minorityOwnedBusiness": minorityOwnedBusiness,
                    "womanOwnedBusiness": womanOwnedBusiness,
                    "disadvantaged": disadvantaged,
                    "disabilityOwnedBusiness": disabilityOwnedBusiness,
                    "lgbtOwned": lgbtOwned,
                    "vetOwnedEnterprise": vetOwnedEnterprise,
                    "smallBusiness": smallBusiness,
                    "queryType": "update",
                    "key": key
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep1("#saveCompanyInfoEditButton");
                    reloadFinalVerificationPage();
                    showStep7();
                    $('#companyP').html(`<p><b>Company Name: ${$("#CompanyNameInput").val()}</b></p><p><b>DBA Name: ${$("#DBANameInput").val()}</b></p>`);
                    $('#showThroughOut').removeClass("hidden");
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //alert(data);
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

$(function () {
    $('#regionAll').on('click', function () {
        if ($("#regionAll").is(":checked")) {
            $('#regions input').each(function () {
                $(this).prop('checked', true);
            });
            //$("#regionAll").prop('checked',false);
        }
    });
});

$(function () {
    $('#saveLocationContactInfo').on('click', function () {
        var selected = [];
        $('#regions input:checked').each(function () {
            var name = $(this).attr('name');
            if (name !== 'regionAll') {
                selected.push($(this).val());
            }
        });
        var phoneData = parsePhoneData(mailingPhoneIti);
        var tollFreeData = parsePhoneData(mailingTollFreeIti);
        var faxData = parsePhoneData(mailingFaxIti);
        var contactData = parsePhoneData(mailingContactPhoneIti);
        $.ajax({
            url: 'applets/saveMailingAddressToTable.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "addrType": "Mailing",
                    "formID": formID,
                    "companyID": companyID,
                    "addrLine1": $("#mailingAddress1Input").val(),
                    "addrLine2": $("#mailingAddress2Input").val(),
                    "city": $("#mailingCityInput").val(),
                    "state": $("#mailingStateInput").val(),
                    "zip": $("#mailingZipInput").val(),
                    "country": $("#mailingCountryInput").val(),
                    "phoneCountry": phoneData.countryData.iso2,
                    "phoneInternationalCode": phoneData.dialCode,
                    "phoneAreaCode": phoneData.areaCode,
                    "phone": phoneData.phoneNum,
                    "phoneExt": $("#mailingPhoneExtInput").val(),
                    "tollFreeCountry": tollFreeData.countryData.iso2,
                    "tollFreeInternationalCode": tollFreeData.dialCode,
                    "tollFreeAreaCode": tollFreeData.areaCode,
                    "tollFreePhone": tollFreeData.phoneNum,
                    "tollFreePhoneExt": $("#tollFreeExtMailingPhoneInput").val(),
                    "faxCountry": faxData.countryData.iso2,
                    "faxInternationalCode": faxData.dialCode,
                    "faxAreaCode": faxData.areaCode,
                    "fax": faxData.phoneNum,
                    "email": $("#mailingEmailInput").val(),
                    "contactFirstName": $("#mailingContactFirstNameInput").val(),
                    "contactMiddleName": $("#mailingContactMiddleNameInput").val(),
                    "contactLastName": $("#mailingContactLastNameInput").val(),
                    "contactName": `${$("#mailingContactFirstNameInput").val()} ${$("#mailingContactMiddleNameInput").val()} ${$("#mailingContactLastNameInput").val()}`,
                    "contactTitle": $("#mailingContactTitleInput").val(),
                    "contactCountry": contactData.countryData.iso2,
                    "contactInternationalCode": contactData.dialCode,
                    "contactAreaCode": contactData.areaCode,
                    "contactPhone": contactData.phoneNum,
                    "contactPhoneExt": $("#mailingContactPhoneExtInput").val(),
                    "contactEmail": $("#mailingContactEmailInput").val(),
                    "selectedRegions": selected,
                    "queryType": "insert"
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep2("#saveLocationContactInfo");
                    showStep3();
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //alert(data);
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

$(function () {
    $('#saveLocationContactInfoEditButton').on('click', function () {
        var selected = [];
        $('#regions input:checked').each(function () {
            var name = $(this).attr('name');
            if (name !== 'regionAll') {
                selected.push($(this).val());
            }
        });

        var phoneData = parsePhoneData(mailingPhoneIti);
        var tollFreeData = parsePhoneData(mailingTollFreeIti);
        var faxData = parsePhoneData(mailingFaxIti);
        var contactData = parsePhoneData(mailingContactPhoneIti);

        $.ajax({
            url: 'applets/saveMailingAddressToTable.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "addrType": "Mailing",
                    "formID": formID,
                    "companyID": companyID,
                    "addrLine1": $("#mailingAddress1Input").val(),
                    "addrLine2": $("#mailingAddress2Input").val(),
                    "city": $("#mailingCityInput").val(),
                    "state": $("#mailingStateInput").val(),
                    "zip": $("#mailingZipInput").val(),
                    "country": $("#mailingCountryInput").val(),
                    "phoneCountry": phoneData.countryData.iso2,
                    "phoneInternationalCode": phoneData.dialCode,
                    "phoneAreaCode": phoneData.areaCode,
                    "phone": phoneData.phoneNum,
                    "phoneExt": $("#mailingPhoneExtInput").val(),
                    "tollFreeCountry": tollFreeData.countryData.iso2,
                    "tollFreeInternationalCode": tollFreeData.dialCode,
                    "tollFreeAreaCode": tollFreeData.areaCode,
                    "tollFreePhone": tollFreeData.phoneNum,
                    "tollFreePhoneExt": $("#tollFreeExtMailingPhoneInput").val(),
                    "faxCountry": faxData.countryData.iso2,
                    "faxInternationalCode": faxData.dialCode,
                    "faxAreaCode": faxData.areaCode,
                    "fax": faxData.phoneNum,
                    "email": $("#mailingEmailInput").val(),
                    "contactFirstName": $("#mailingContactFirstNameInput").val(),
                    "contactMiddleName": $("#mailingContactMiddleNameInput").val(),
                    "contactLastName": $("#mailingContactLastNameInput").val(),
                    "contactName": `${$("#mailingContactFirstNameInput").val()} ${$("#mailingContactMiddleNameInput").val()} ${$("#mailingContactLastNameInput").val()}`,
                    "contactTitle": $("#mailingContactTitleInput").val(),
                    "contactCountry": contactData.countryData.iso2,
                    "contactInternationalCode": contactData.dialCode,
                    "contactAreaCode": contactData.areaCode,
                    "contactPhone": contactData.phoneNum,
                    "contactPhoneExt": $("#mailingContactPhoneExtInput").val(),
                    "contactEmail": $("#mailingContactEmailInput").val(),
                    "selectedRegions": selected,
                    "queryType": "update"
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep2("#saveLocationContactInfoEditButton");
                    reloadFinalVerificationPage();
                    showStep7();
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //alert(data);
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

$(function () {
    $('#saveRemitInfo').on('click', function () {
        var phoneData = parsePhoneData(remitPhoneIti);
        var tollFreeData = parsePhoneData(remitTollFreeIti);
        var faxData = parsePhoneData(remitFaxIti);
        var contactData = parsePhoneData(remitContactPhoneIti);
        console.log(contactData);
        $.ajax({
            url: 'applets/saveMailingAddressToTable.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "addrType": "Remit",
                    "formID": formID,
                    "companyID": companyID,
                    "addrLine1": $("#remitAddress1Input").val(),
                    "addrLine2": $("#remitAddress2Input").val(),
                    "city": $("#remitCityInput").val(),
                    "state": $("#remitState").val(),
                    "zip": $("#remitZipInput").val(),
                    "country": $("#remitCountyInput").val(),
                    "phoneCountry": phoneData.countryData.iso2,
                    "phoneInternationalCode": phoneData.dialCode,
                    "phoneAreaCode": phoneData.areaCode,
                    "phone": phoneData.phoneNum,
                    "phoneExt": $("#remitPhoneExtInput").val(),
                    "tollFreeCountry": tollFreeData.countryData.iso2,
                    "tollFreeInternationalCode": tollFreeData.dialCode,
                    "tollFreeAreaCode": tollFreeData.areaCode,
                    "tollFreePhone": tollFreeData.phoneNum,
                    "tollFreePhoneExt": $("#remitTollFreePhoneExtInput").val(),
                    "faxCountry": faxData.countryData.iso2,
                    "faxInternationalCode": faxData.dialCode,
                    "faxAreaCode": faxData.areaCode,
                    "fax": faxData.phoneNum,
                    "email": $("#remitEmailInput").val(),
                    "contactFirstName": $("#remitContactFirstNameInput").val(),
                    "contactMiddleName": $("#remitContactMiddleNameInput").val(),
                    "contactLastName": $("#remitContactLastNameInput").val(),
                    "contactName": `${$("#remitContactFirstNameInput").val()} ${$("#remitContactMiddleNameInput").val()} ${$("#remitContactLastNameInput").val()}`,
                    "contactTitle": $("#remitContactTitleInput").val(),
                    "contactCountry": contactData.countryData.iso2,
                    "contactInternationalCode": contactData.dialCode,
                    "contactAreaCode": contactData.areaCode,
                    "contactPhone": contactData.phoneNum,
                    "contactPhoneExt": $("#remitContactPhoneExtInput").val(),
                    "contactEmail": $("#remitContactEmailInput").val(),
                    "queryType": "insert"
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep3("#saveRemitInfo");
                    showStep4();
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //alert(data);
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

$(function () {
    $('#saveRemitInfoEditButton').on('click', function () {
        var phoneData = parsePhoneData(remitPhoneIti);
        var tollFreeData = parsePhoneData(remitTollFreeIti);
        var faxData = parsePhoneData(remitFaxIti);
        var contactData = parsePhoneData(remitContactPhoneIti);
        $.ajax({
            url: 'applets/saveMailingAddressToTable.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "addrType": "Remit",
                    "formID": formID,
                    "companyID": companyID,
                    "addrLine1": $("#remitAddress1Input").val(),
                    "addrLine2": $("#remitAddress2Input").val(),
                    "city": $("#remitCityInput").val(),
                    "state": $("#remitState").val(),
                    "zip": $("#remitZipInput").val(),
                    "country": $("#remitCountyInput").val(),
                    "phoneCountry": phoneData.countryData.iso2,
                    "phoneInternationalCode": phoneData.dialCode,
                    "phoneAreaCode": phoneData.areaCode,
                    "phone": phoneData.phoneNum,
                    "phoneExt": $("#remitPhoneExtInput").val(),
                    "tollFreeCountry": tollFreeData.countryData.iso2,
                    "tollFreeInternationalCode": tollFreeData.dialCode,
                    "tollFreeAreaCode": tollFreeData.areaCode,
                    "tollFreePhone": tollFreeData.phoneNum,
                    "tollFreePhoneExt": $("#remitTollFreePhoneExtInput").val(),
                    "faxCountry": faxData.countryData.iso2,
                    "faxInternationalCode": faxData.dialCode,
                    "faxAreaCode": faxData.areaCode,
                    "fax": faxData.phoneNum,
                    "email": $("#remitEmailInput").val(),
                    "contactFirstName": $("#remitContactFirstNameInput").val(),
                    "contactMiddleName": $("#remitContactMiddleNameInput").val(),
                    "contactLastName": $("#remitContactLastNameInput").val(),
                    "contactName": `${$("#remitContactFirstNameInput").val()} ${$("#remitContactMiddleNameInput").val()} ${$("#remitContactLastNameInput").val()}`,
                    "contactTitle": $("#remitContactTitleInput").val(),
                    "contactCountry": contactData.countryData.iso2,
                    "contactInternationalCode": contactData.dialCode,
                    "contactAreaCode": contactData.areaCode,
                    "contactPhone": contactData.phoneNum,
                    "contactPhoneExt": $("#remitContactPhoneExtInput").val(),
                    "contactEmail": $("#remitContactEmailInput").val(),
                    "queryType": "update"
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep3("#saveRemitInfoEditButton");
                    reloadFinalVerificationPage();
                    showStep7();
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //alert(data);
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

//TODO: copying phone numbers
$(function () {
    $('#copyMailingAddress').on('change', function () {
        if ($("#copyMailingAddress").is(":checked")) {
            $("#remitAddress1Input").val($("#mailingAddress1Input").val());
            $("#remitAddress2Input").val($("#mailingAddress2Input").val());
            $("#remitCityInput").val($("#mailingCityInput").val());
            $("#remitState").val($("#mailingStateInput").val());
            $("#remitZipInput").val($("#mailingZipInput").val());
            $("#remitCountyInput").val($("#mailingCountryInput").val());

            copyIntlPhone(remitPhoneIti, mailingPhoneIti);

            $("#remitPhoneExtInput").val($("#mailingPhoneExtInput").val());

            copyIntlPhone(remitTollFreeIti, mailingTollFreeIti);

            $("#remitTollFreePhoneExtInput").val($("#tollFreeExtMailingPhoneInput").val());

            copyIntlPhone(remitFaxIti, mailingFaxIti);

            $("#remitEmailInput").val($("#mailingEmailInput").val());
        }
        else {
            $("#remitAddress1Input").val("");
            $("#remitAddress2Input").val("");
            $("#remitCityInput").val("");
            $("#remitState").val("LA");
            $("#remitZipInput").val("");
            $("#remitCountyInput").val("");
            remitPhoneIti.setNumber("");
            remitPhoneIti.setCountry("us");
            $("#remitPhoneExtInput").val("");
            remitTollFreeIti.setNumber("");
            remitTollFreeIti.setCountry("us");
            $("#remitTollFreePhoneExtInput").val("");
            remitFaxIti.setNumber("");
            remitFaxIti.setCountry("us");
            $("#remitEmailInput").val("");
        }
    });
});

function copyIntlPhone(object1, object2) {
    object1.setNumber(object2.getNumber());
    console.log(object2.getSelectedCountryData());
    object1.setCountry(object2.getSelectedCountryData().iso2);
}

//TODO: copying phone numbers
$(function () {
    $('#copyMailingContact').on('change', function () {
        if ($("#copyMailingContact").is(":checked")) {
            $("#remitContactNameInput").val($("#mailingContactNameInput").val());
            $("#remitContactFirstNameInput").val($("#mailingContactFirstNameInput").val());
            $("#remitContactMiddleNameInput").val($("#mailingContactMiddleNameInput").val());
            $("#remitContactLastNameInput").val($("#mailingContactLastNameInput").val());
            $("#remitContactTitleInput").val($("#mailingContactTitleInput").val());

            copyIntlPhone(remitContactPhoneIti, mailingContactPhoneIti);

            $("#remitContactPhoneExtInput").val($("#mailingContactPhoneExtInput").val());
            $("#remitContactEmailInput").val($("#mailingContactEmailInput").val());

        }
        else {
            $("#remitContactNameInput").val("");
            $("#remitContactFirstNameInput").val("");
            $("#remitContactMiddleNameInput").val("");
            $("#remitContactLastNameInput").val("");
            $("#remitContactTitleInput").val("");
            remitContactPhoneIti.setNumber("");
            remitContactPhoneIti.setCountry("us");
            $("#remitContactPhoneExtInput").val("");
            $("#remitContactEmailInput").val("");
        }
    });
});

$(function () {
    $('input[name=employeeCheck]').on('change', function () {
        if ($("input[name=employeeCheck]:checked").val() === "Yes") {
            $("#employeeCheckJustifyRow").show("fast");

        }
        else {
            $("#employeeCheckJustifyRow").hide("fast");
        }
    });
});

$(function () {
    $('input[name=familyCheck]').on('change', function () {
        if ($("input[name=familyCheck]:checked").val() === "Yes") {
            //alert("checked");
            $("#familyCheckJustifyRow").show("fast");

        }
        else {
            //alert("unchecked");
            $("#familyCheckJustifyRow").hide("fast");
        }
    });
});

$(function () {
    $('#mailingCountryInput').on('change', function () {
        if ($("#mailingCountryInput").val() === "US") {
            $("#mailingStateInput").prop("disabled", false);
        }
        else {
            $("#mailingStateInput").prop("disabled", true);
            $("#remitState").val("F");
        }
    });
});

$(function () {
    $('#remitCountyInput').on('change', function () {
        if ($("#remitCountyInput").val() === "US") {
            $("#remitState").prop("disabled", false);
        }
        else {
            $("#remitState").prop("disabled", true);
            $("#remitState").val("F");
        }
    });
});

$(function () {
    $('#adhocCountryInput').on('change', function () {
        if ($("#adhocCountryInput").val() === "US") {
            $("#StateInput").prop("disabled", false);
        }
        else {
            $("#StateInput").prop("disabled", true);
            $("#StateInput").val("F");
        }
    });
});

$(function () {
    $('#saveSupplierPaymentOptions').on('click', function () {
        $.ajax({
            url: 'applets/updateCompanyInfoPaymentOption.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "companyID": companyID,
                    "formID": formID,
                    "supplierPaymentOption": $("input[name=enrollPay]:checked").val(),
                    "employeeConfirm": $("input[name=employeeCheck]:checked").val(),
                    "employeeJustification": $("#employeeCheckJustify").val(),
                    "familyEmployeeConfirm": $("input[name=familyCheck]:checked").val(),
                    "familyJustification": $("#familyCheckJustify").val()
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep4('#saveSupplierPaymentOptions');
                    showStep5();
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //alert(data);
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

$(function () {
    $('#saveSupplierPaymentOptionsEditButton').on('click', function () {
        $.ajax({
            url: 'applets/updateCompanyInfoPaymentOption.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "companyID": companyID,
                    "formID": formID,
                    "supplierPaymentOption": $("input[name=enrollPay]:checked").val(),
                    "employeeConfirm": $("input[name=employeeCheck]:checked").val(),
                    "employeeJustification": $("#employeeCheckJustify").val(),
                    "familyEmployeeConfirm": $("input[name=familyCheck]:checked").val(),
                    "familyJustification": $("#familyCheckJustify").val()
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep4('#saveSupplierPaymentOptions');
                    reloadFinalVerificationPage();
                    showStep7();
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //alert(data);
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = 'An unknown error occurred while processing your request. ERROR: ' + thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

$(function () {
    $('#saveBusinessCategory').on('click', function () {
        var selectedSuppliersGroup = [];

        $('#selectedSupplierGroups option').each(function () {
            selectedSuppliersGroup.push($(this).val());
        });

        if (selectedSuppliersGroup[0] == null) {
            var output_msg = "A Supplier Group was not selected. Please select at least one Supplier Group before continuing.";
            showMessageBox(output_msg, 'No Supplier Group selected', "warning");
            return false;
        }
        else if (selectedSuppliersGroup.length > 5) {
            var output_msg = "There are more than 5 Supplier Groups selected. Please select between 1-5 Supplier Groups.";
            showMessageBox(output_msg, 'Too many Supplier Groups selected', "warning");
            return false;
        }

        $.ajax({
            url: 'applets/saveSupplierGroup.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "formID": formID,
                    "companyID": companyID,
                    "selectedSupplierGroups": selectedSuppliersGroup
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST. Please try again.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST. Please try again.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep5("#saveBusinessCategory");
                    showStep6();
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

$(function () {
    $('#saveBusinessCategoryEditButton').on('click', function () {
        var selectedSuppliersGroup = [];

        $('#selectedSupplierGroups option').each(function () {
            selectedSuppliersGroup.push($(this).val());
        });

        if (selectedSuppliersGroup[0] == null) {
            var output_msg = "A Supplier Group was not selected. Please select at least one Supplier Group before continuing.";
            showMessageBox(output_msg, 'No Supplier Group selected', "warning");
            return false;
        }
        else if (selectedSuppliersGroup.length > 5) {
            var output_msg = "There are more than 5 Supplier Groups selected. Please select between 1-5 Supplier Groups.";
            showMessageBox(output_msg, 'Too many Supplier Groups selected', "warning");
            return false;
        }

        $.ajax({
            url: 'applets/saveSupplierGroup.php',
            method: 'POST',
            data: {
                input: JSON.stringify({
                    "formID": formID,
                    "companyID": companyID,
                    "selectedSupplierGroups": selectedSuppliersGroup
                })
            },
            dataType: "JSON",
            success: function (data) {
                if (data == null) {
                    var output_msg = "An invalid response was recieved from the HOST. Please try again.";
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.error != undefined && data.error.hasOwnProperty('e')) {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                if (data.success == undefined) {
                    var output_msg = 'An invalid response was recieved from the HOST. Please try again.';
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                    var output_msg = data.success.msg;;
                    //showMessageBox(output_msg, 'Success', 'success');
                    hideStep5("#saveBusinessCategory");
                    reloadFinalVerificationPage();
                    showStep7();
                    return true;
                }
                else {
                    var output_msg = data.error.error;
                    showMessageBox(output_msg, 'Error', 'error');
                    return false;
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                if (xhr.status == 404 || thrownError == 'Not Found') {
                    var output_msg = thrownError;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
                else {
                    var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                    showMessageBox(output_msg, 'Error saving information', "error");
                    return false;
                }
            }
        });
    });
});

$(function () {
    $('#beginRegistrationProcess').on('click', function () {
        $('#notifications').addClass("hidden");
        $('#beginProcess').removeClass("hidden");
        showStep1();
    })
});

$(function () {
    $('#clearForm').on('click', function () {
        alert('Clear the Form Here');
    });
});

$(function () {
    $('#saveAdHoc').on('click', function () {
        var d = new Date().toISOString().slice(0, 19).replace('T', ' ');
        formID = $("#NameInput").val().replace(/[^A-Za-z0-9\s:-]/g, '').substring(0, 30) + d;
        var comment = $('#commentInput').val();
        if (comment !== null && comment.trim() !== '') {
            $.ajax({
                url: 'applets/saveComment.php',
                method: 'POST',
                data: {
                    "formID": formID,
                    "comment": comment,
                    "userID": 'Supplier Comment'
                },
                dataType: "JSON",
                success: function (data) {
                    if (data == null) {
                        var output_msg = "An invalid response was recieved from the HOST. Please try again.";
                        showMessageBox(output_msg, 'Error saving information', "error");
                        return false;
                    }
                    if (data.error != undefined && data.error.hasOwnProperty('e')) {
                        var output_msg = data.error.error;
                        showMessageBox(output_msg, 'Error saving information', "error");
                        return false;
                    }
                    if (data.success == undefined) {
                        var output_msg = 'An invalid response was recieved from the HOST. Please try again.';
                        showMessageBox(output_msg, 'Error saving information', "error");
                        return false;
                    }
                    else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                        saveAdHocInformation();
                    }
                    else {
                        var output_msg = data.error.error;
                        showMessageBox(output_msg, 'Error saving comment', "error");
                        return false;
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (xhr.status == 404 || thrownError == 'Not Found') {
                        var output_msg = thrownError;
                        showMessageBox(output_msg, 'Error saving comment', "error");
                        return false;
                    }
                    else {
                        var output_msg = thrownError;
                        showMessageBox(output_msg, 'Error saving comment', "error");
                        return false;
                    }
                }
            });
        }
        else {
            saveAdHocInformation();
        }
    });
});

function saveAdHocInformation() {
    $.ajax({
        url: 'applets/saveAdHoc.php',
        method: 'POST',
        data: {
            input: JSON.stringify({
                "companyName": $("#NameInput").val(),
                "taxID": $('#TaxIDInput').val(),
                //"duns" : DUNS,
                "submittedByInternationalCode": $("#mainPhoneCountry").val(),
                "submittedByAreaCode": $("#PhoneAreaCode").val(),
                "submittedByPhone": $("#PhoneInput").val(),
                "submittedByEmail": $("#EmailInput").val(),
                "backupWithHolding": $("input[name=backupWithHolding]:checked").val(),
                "usPerson": $("input[name=usPerson]:checked").val(),
                "correctFEIN": $("input[name=correctFEIN]:checked").val(),
                "addrLine1": $("#Address1Input").val(),
                "addrLine2": $("#Address2Input").val(),
                "city": $("#CityInput").val(),
                "state": $("#StateInput").val(),
                "zip": $("#ZipInput").val(),
                "country": $("#adhocCountryInput").val(),
                "employeeConfirm": $("input[name=employeeCheck]:checked").val(),
                "employeeJustification": $("#employeeCheckJustify").val(),
                "familyEmployeeConfirm": $("input[name=familyCheck]:checked").val(),
                "familyJustification": $("#familyCheckJustify").val(),
                "purposeForPayment": $("#PurposeInput").val(),
                "formID": formID,
            })
        },
        dataType: "JSON",
        success: function (data) {
            if (data == null) {
                var output_msg = "An invalid response was recieved from the HOST.";
                showMessageBox(output_msg, 'Error saving information', "error");
                return false;
            }
            if (data.error != undefined && data.error.hasOwnProperty('e')) {
                var output_msg = data.error.error;
                showMessageBox(output_msg, 'Error saving information', "error");
                return false;
            }
            if (data.success == undefined) {
                var output_msg = 'An invalid response was recieved from the HOST.';
                showMessageBox(output_msg, 'Error saving information', "error");
                return false;
            }
            else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                companyID = data.success.companyID;
                startK2SupplierRequestProcess('True');
                return true;
            }
            else {
                var output_msg = data.error.error;
                showMessageBox(output_msg, 'Error', 'error');
                return false;
            }
        },
        error: function (xhr, ajaxOptions, thrownError) {
            //alert(data);
            if (xhr.status == 404 || thrownError == 'Not Found') {
                var output_msg = thrownError;
                showMessageBox(output_msg, 'Error saving information', "error");
                return false;
            }
            else {
                var output_msg = `An unknown error occurred while processing your request. ERROR: ${thrownError}`;
                showMessageBox(output_msg, 'Error saving information', "error");
                return false;
            }
        }
    });
}

function showMessageBox(messageToShow, messageTitle, type) {
    var html = `<div>
                    <table>
                        <tr>
                            <td><span class="messageBoxIcon"></span></td>
                            <td><span>${messageToShow}</span></td>
                        </tr>
                    </table>
                <div>`;
    $(`<div id="messageBox" class="${type}"></div>"`).html(html).dialog({
        title: messageTitle,
        resizable: false,
        modal: true,
        dialogClass: 'messageBox',
        open: function () {
            $('.ui-dialog').addClass(type);
            $('.ui-dialog').removeClass('ui-corner-all');
        },
        buttons: {
            "Ok": function () {
                $(this).dialog('destroy').remove();
                return true;
            }
        },
        close: function (event, ui) {
            $('.ui-dialog').removeClass(type);
            $(this).dialog('destroy').remove();
            return false;
        }
    });
}

function showMessageBoxRedirect(messageToShow, messageTitle, type, redirectPage) {
    var html = `<div>
                    <table>
                        <tr>
                            <td><span class="messageBoxIcon"></span></td>
                            <td><span>${messageToShow}</span></td>
                        </tr>
                    </table>
                <div>`;
    $(`<div id="messageBox" class="'${type}'"></div>"`).html(html).dialog({
        title: messageTitle,
        resizable: false,
        modal: true,
        dialogClass: 'messageBox',
        open: function () {
            $('.ui-dialog').addClass(type);
            $('.ui-dialog').removeClass('ui-corner-all');
        },
        buttons: {
            "Ok": function () {
                $(this).dialog('destroy').remove();
                window.location.replace(redirectPage);
                return true;
            }
        },
        close: function (event, ui) {
            $('.ui-dialog').removeClass(type);
            $(this).dialog('destroy').remove();
            return false;
        }
    });
}
// make a new function that allows this to be reused for DUNS
function validateTaxID (inputField){
    $(inputField).prop("value", function (i, o){
        return o.replace(/[^\d]/g, "");
    });
}

//Tax ID
$(function () {
    $('#TaxIDInput').on("keyup", function(e){
        validateTaxID(this);
    });
});
//Duns
$(function () {
    $('#DUNSInput').on("keyup", function (e) {
        validateTaxID(this);
    });
});

//allow only numbers in phone input
$(function () {
    $('#PhoneInput, #mainPhoneCountry, #PhoneAreaCode, #PhoneExtInput, ' +
        '#remitContactInternationalCode, #remitContactAreaCode, #remitContactPhoneInput, #remitContactPhoneExtInput, ' +
        '#remitFaxInternationalCode, #remitFaxAreaCode, #remitFaxPhoneInput, ' +
        '#remitTollFreeInternationalCode, #remitTollFreeAreaCode, #remitTollFreePhoneInput, #remitTollFreePhoneExtInput, ' +
        '#remitPhoneInternationalCode, #remitPhoneAreaCode, #remitPhoneInput, #remitPhoneExtInput, ' +
        '#mailingContactInternationalCode, #mailingContactAreaCode, #mailingContactPhoneInput, #mailingContactPhoneExtInput, ' +
        '#mailingFaxInternationalCode, #mailingFaxAreaCode, #mailingFaxInput, #mailingTollFreeAreaCode, #tollFreeMailingPhoneInput, #tollFreeExtMailingPhoneInput, ' +
        '#mailingPhoneInternationalCode, #mailingPhoneAreaCode, #mailingPhoneInput, #mailingPhoneExtInput').on("keyup", function (e) {
            $(this).prop("value", function (i, o) {
                var input = o.replace(/[^0-9]/, "");
                var keyCode = e.code;
                if ((keyCode < 47) || (keyCode > 58)) {
                    return o.replace(/\D/g, "");
                }
            })
        });
});

function reloadFinalVerificationPage() {
    $('#VerificationInput').html("");
    var html = `<br> 
                <span class="headerSpan" id="step7Banner1">Company Information</span>
                <table class="verifyTable">
                    <tbody>
                        <tr>
                            <td class="td1">
                                <span class="bold">Company/Individual Name:</span>
                            </td>
                            <td class="td2">
                                <span>${$("#CompanyNameInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Company Division/DBA Name:</span>
                            </td>
                            <td class="td2">
                                <span>${$("#DBANameInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Business URL:</span>
                            </td>
                            <td class="td2">
                                <span>${$("#BusinessURLInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Tax ID Type: </span></br>
                            </td>
                            <td class="td2">
                                <span>${$("#taxIDType").children(':selected').text()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Tax ID (FEIN/SSN): </span></br>
                            </td>
                            <td class="td2">
                                <span>${$("#TaxIDInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">DUNS: </span></br>
                            </td>
                            <td class="td2">
                                <span>${$("#DUNSInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Submitted By:</span>
                            </td>
                            <td class="td2">
                                <span>${$("#PrimaryContactFirstNameInput").val()} ${$("#PrimaryContactMiddleNameInput").val()} ${$("#PrimaryContactLastNameInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Submitted By Title:</span>
                            </td>
                            <td class="td2">
                                <span>${$("#PrimaryContactTitleInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Phone:</span><br/>
                            </td>
                            <td class="td2">
                                <span>${phoneIti.getNumber()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Email:</span>
                            </td>
                            <td class="td2">
                                <span>${$("#EmailInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">Business Organization Type:</span>
                            </td>
                            <td class="td2">
                                <span>${$("input[name=businessType]:checked").parent().text()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">LSU Department Name:</span>
                            </td>
                            <td class="td2">
                                <span>${$("#DepartmentNameInput").val()}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="td1">
                                <span class="bold">LSU Department Contact:</span>
                            </td>
                            <td class="td2">
                                <span>${$("#DepartmentContactInput").val()}</span>
                            </td>
                        </tr>`;
    var firstRow = true;
    if ($("#minorityOwnedBusiness").is(":checked")) {
        if (firstRow === true) {
            html += `<tr>
                                <td class="td1">
                                    <span class="bold">Diverse Supplier Classifications:</span>
                                </td>
                                <td class="td2">
                                    <span>Minority Owned Business</span>
                                </td>
                            </tr>`;
            firstRow = false;
        }
        else {
            html += `<tr>
                                <td class="td1">
                                    <span></span>
                                </td>
                                <td class="td2">
                                    <span>Minority Owned Business</span>
                                </td>
                             </tr>`;
        }
    }
    if ($("#womanOwnedBusiness").is(":checked")) {
        if (firstRow === true) {
            html += `<tr>
                                <td class="td1">
                                    <span class="bold">Diverse Supplier Classifications:</span>
                                </td>
                                <td class="td2">
                                    <span>Woman Owned Business</span>
                                </td>
                            </tr>`;
            firstRow = false;
        }
        else {
            html += `<tr>
                                <td class="td1">
                                    <span></span>
                                </td>
                                <td class="td2">
                                    <span>Woman Owned Business</span>
                                </td>
                            </tr>`;
        }
    }
    if ($("#disadvantaged").is(":checked")) {
        if (firstRow === true) {
            html += `<tr>
                                <td class="td1">
                                    <span class="bold">Diverse Supplier Classifications:</span>
                                </td>
                                <td class="td2">
                                    <span>Disadvantaged Business Enterprise (DBE)</span>
                                </td>
                            </tr>`;
            firstRow = false;
        }
        else {
            html += `<tr>
                                <td class="td1">
                                    <span></span>
                                </td>
                                <td class="td2">
                                    <span>Disadvantaged Business Enterprise (DBE)</span>
                                </td>
                            </tr>`;
        }
    }
    if ($("#disabilityOwnedBusiness").is(":checked")) {
        if (firstRow === true) {
            html += `<tr>
                                <td class="td1">
                                    <span class="bold">Diverse Supplier Classifications:</span>
                                </td>
                                <td class="td2">
                                    <span>Disability-Owned Business Enterprise (DOBE)</span>
                                </td>
                            </tr>`;
            firstRow = false;
        }
        else {
            html += `<tr>
                                <td class="td1">
                                    <span></span>
                                </td>
                                <td class="td2">
                                    <span>Disability-Owned Business Enterprise (DOBE)</span>
                                </td>
                            </tr>`;
        }
    }
    if ($("#lgbtOwned").is(":checked")) {
        if (firstRow === true) {
            html += `<tr>
                                <td class="td1">
                                    <span class="bold">Diverse Supplier Classifications:</span>
                                </td>
                                <td class="td2">
                                    <span>Lesbian, Gay, Bisexual, Transgender-Owned Business Enterprise (LGBTBE)</span>
                                </td>
                            </tr>`;
            firstRow = false;
        }
        else {
            html += `<tr>
                                <td class="td1">
                                    <span></span>
                                </td>
                                <td class="td2">
                                    <span>Lesbian, Gay, Bisexual, Transgender-Owned Business Enterprise (LGBTBE)</span>
                                </td>
                            </tr>`;
        }
    }
    if ($("#vetOwnedEnterprise").is(":checked")) {
        if (firstRow === true) {
            html += `<tr>
                                <td class="td1">
                                    <span class="bold">Diverse Supplier Classifications:</span>
                                </td>
                                <td class="td2">
                                    <span>Veteran-Owned Business Enterprise</span>
                                </td>
                            </tr>`;
            firstRow = false;
        }
        else {
            html += `<tr>
                                <td class="td1">
                                    <span></span>
                                </td>
                                <td class="td2">
                                    <span>Veteran-Owned Business Enterprise</span>
                                </td>
                            </tr>`;
        }
    }
    if ($("#smallBusiness").is(":checked")) {
        if (firstRow === true) {
            html += `<tr>
                                <td class="td1">
                                    <span class="bold">Diverse Supplier Classifications:</span> 
                                </td>
                                <td class="td2">
                                    <span>Small Business</span>
                                </td>
                            </tr>`;
            firstRow = false;
        }
        else {
            html += `<tr>
                                <td class="td1">
                                    <span></span> 
                                </td>
                                <td class="td2">
                                    <span>Small Business</span>
                                </td>
                            </tr>`;
        }
    }
    html += '</tbody>';
    html += `<tr>
                        <td class="td1">
                        </td>
                        <td class="td2">
                            <button type="button" class="button" id="editCompanyInfoButton">Edit Info</button>
                        </td>
                    </tr>
                </table>
                <br>
                <span class="headerSpan" id="step7Banner2">Mailing Address Information</span>`;
    var selected = [];
    $('#regions input:checked').each(function () {
        var name = $(this).attr('name');
        if (name !== 'regionAll') {
            selected.push($(this).val());
        }
    });
    html += `<table class="verifyTable">
                    <tr>
                        <td class="td1">
                            <span class="bold">State Regions:</span>
                        </td>
                        <td class="td2">
                            <span>${selected}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Mailing Address 1:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingAddress1Input").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Mailing Address 2:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingAddress2Input").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">City:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingCityInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">State:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingStateInput").children(':selected').text()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Zip:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingZipInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Country:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingCountryInput").children(':selected').text()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Phone:</span>
                        </td>
                        <td class="td2">
                            <span>${mailingPhoneIti.getNumber()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Phone Ext:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingPhoneExtInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Toll Free Phone:</span>
                        </td>
                        <td class="td2">
                            <span>${mailingTollFreeIti.getNumber()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Toll Free Phone Ext:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#tollFreeExtMailingPhoneInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Fax:</span>
                        </td>
                        <td class="td2">
                            <span>${mailingFaxIti.getNumber()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Email:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingEmailInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Name:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingContactFirstNameInput").val()} ${$("#mailingContactMiddleNameInput").val()} ${$("#mailingContactLastNameInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Title:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingContactTitleInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Phone:</span>
                        </td>
                        <td class="td2">
                            <span>${mailingContactPhoneIti.getNumber()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Phone Ext:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingContactPhoneExtInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Email:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#mailingContactEmailInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                        </td>
                        <td class="td2">
                            <button type="button" class="button" id="editMailingInfo">Edit Info</button>
                        </td>
                    </tr>
                </table>
                <br>
                <span class="headerSpan" id="step7Banner3">Remittance Address Information</span>
                <table class="verifyTable">
                    <tr>
                        <td class="td1">
                            <span class="bold">Remittance Address 1:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitAddress1Input").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Remittance Address 2:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitAddress2Input").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">City:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitCityInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">State:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitState").children(':selected').text()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Zip:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitZipInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Country:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitCountyInput").children(':selected').text()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Phone:</span>
                        </td>
                        <td class="td2">
                            <span>${remitPhoneIti.getNumber()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Phone Ext:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitPhoneExtInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Toll Free Phone:</span>
                        </td>
                        <td class="td2">
                            <span>${remitTollFreeIti.getNumber()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Toll Free Phone Ext:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitTollFreePhoneExtInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Fax:</span>
                        </td>
                        <td class="td2">
                            <span>${remitFaxIti.getNumber()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Email:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitEmailInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Name:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitContactFirstNameInput").val()} ${$("#remitContactMiddleNameInput").val()} ${$("#remitContactLastNameInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Title:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitContactTitleInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Phone:</span>
                        </td>
                        <td class="td2">
                            <span>${remitContactPhoneIti.getNumber()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Phone Ext:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitContactPhoneExtInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                            <span class="bold">Contact Email:</span>
                        </td>
                        <td class="td2">
                            <span>${$("#remitContactEmailInput").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                        </td>
                        <td class="td2">
                            <button type="button" class="button" id="editRemitInfo">Edit Info</button>
                        </td>
                    </tr>
                </table>
            <br>
                <span class="headerSpan" id="step7Banner4">Supplier Payment Option</span>
                <table class="verifyTable">
                    <tr>
                        <td class="td1">
                            <span class="bold">Selected Payment Option:</span>
                        </td>
                        <td class="td2">
                            <span>${$("input[name=enrollPay]:checked").val()}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="td1">
                        </td>
                        <td class="td2">
                            <button type="button" class="button" id="editPaymentOption">Edit Info</button>
                        </td>
                    </tr>
                </table>
                <br>
                <span class="headerSpan" id="step7Banner4">Relationship Disclosure</span>
                <table class="verifyTable">
                    <tr>
                        <td class="td3 bold">
                            Are you, or any Officer, Director, Owner or Partner in this company, an employee or former employee of LSU?
                        </td>
                        <td>
                            <span>${$("input[name=employeeCheck]:checked").val()}</span>
                        </td>
                    <tr>
                    </tr>
                        <td class="td3 bold">
                            Is a direct family member of any of the above an employee of LSU?
                        </td>
                        <td>
                            <span>${$("input[name=familyCheck]:checked").val()}</span>
                        </td>
                    </tr>
                </table>
                <table class="verifyTable">
                    <tr>
                        <td class="td1">
                        </td>
                        <td class="td2">
                            <button type="button" class="button" id="editRelationship">Edit Info</button>
                        </td>
                    </tr>
                </table>
                <br>
                <span class="headerSpan" id="step7Banner5">Selected Supplier Groups</span>
                <table class="verifyTable">`;

    var i = 0;
    $('#selectedSupplierGroups option').each(function () {
        html += `<tr>
                        <td class="td3 bold">
                            <span>${$(this).text()}</span>
                        </td>
                        <td>
                            <span></span>
                        </td>
                    <tr>`;
        i++;
    });
    html += `<tr>
                        <td class="td1">
                        </td>
                        <td class="td2">
                            <button type="button" class="button" id="editSupplierGroups">Edit Info</button>
                        </td>
                    </tr>
                </table>
                <br/>`;

    $('#VerificationInput').html(html);
}

function toggleSubmitButton(hide) {
    console.log("HIDE VALUE IS " + hide);

    if (hide) {
        $('#submitRequest').hide();
    }
    else {
        $('#submitRequest').show();
    }
}

function toggleLoadingImage(show) {
    console.log("LOADING IMAGE: SHOW VALUE IS " + show);
    if (show) {
        $('#processingWaitDiv').show();
    }
    else {
        $('#processingWaitDiv').hide();
    }
}

$(function () { 
    $('#submitRequest').on('click', function () {
        toggleSubmitButton(true);
        toggleLoadingImage(true);

        var returnValue = true; 
        if (formID === null || companyID === null) {
            var output_msg = "The request could not be submitted at this time.  Please try again later.";
            showMessageBox(output_msg, 'Error saving information', "error");
            return false;
        }
        var comment = $('#commentInput').val();
        if (comment !== null && comment.trim() !== '') {
            $.ajax({
                url: 'applets/saveComment.php',
                method: 'POST',
                data: {
                    "formID": formID,
                    "comment": comment,
                    "userID": 'Supplier Comment'
                },
                dataType: "JSON",
                success: function (data) {
                    
                    if (data == null && data.success == undefined) {
                        var output_msg = "An invalid response was recieved from the HOST. Please try again.";
                        showMessageBox(output_msg, 'Error saving information', "error");
                        returnValue = false;
                    }
                    else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                        startK2SupplierRequestProcess('False');
                    }
                    else {
                        var output_msg = "An invalid response was recieved from the HOST. Please try again.";
                        showMessageBox(output_msg, 'Error saving information', "error");
                        returnValue = false;
                    }
                    toggleSubmitButton(returnValue);
                    toggleLoadingImage(returnValue);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (xhr.responseJSON.error && xhr.responseJSON.error.error) {
                        showMessageBox(xhr.responseJSON.error.error, 'Error saving comment', "error");
                    }
                    else if (xhr.status == 404 || thrownError == 'Not Found') {
                        var output_msg = thrownError;
                        showMessageBox(output_msg, 'Error saving comment', "error");
                    }
                    else {
                        var output_msg = (thrownError) ? thrownError : xhr.responseText;
                        showMessageBox(output_msg, 'Error saving comment', "error");
                    }
                    toggleSubmitButton(false);
                    toggleLoadingImage(false);
                }
            });
            
        }
        else {
            startK2SupplierRequestProcess('False');
        }
    });
});


function startK2SupplierRequestProcess(adHoc) {
    $.ajax({
        url: 'applets/startVendorRegistrationK2Process.php',
        method: 'POST',
        data: {
            input: JSON.stringify({
                "formID": formID,
                "companyID": companyID,
                "adHoc": adHoc
            })
        },
        dataType: "JSON",
        success: function (data) {
            if (data == null && data.success == undefined) {
                var output_msg = "An invalid response was recieved from the HOST. Please try again.";
                showMessageBox(output_msg, 'Error saving information', "error");
            }
            else if (data.success.hasOwnProperty('s') && data.success.s == 1) {
                var output_msg = data.success.msg;
                showMessageBoxRedirect("<b>Thank you for enrolling with LSU!</b>", "Thank You", "success", "http://www.lsu.edu/administration/ofa/procurement/index.php");
                toggleLoadingImage(false);
                toggleSubmitButton(true);
                return;
            }
            else {
                var output_msg = data.error.error;
                showMessageBox(output_msg, 'Error', 'error');
            }

            toggleSubmitButton(false);
            toggleLoadingImage(false);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            if (xhr.status == 404 || thrownError == 'Not Found') {
                var output_msg = thrownError + " Please refresh the page and try filling out the form again.";
                showMessageBox(output_msg, 'Error saving information', "error");
            }
            else {
                var output_msg = 'An unknown error occurred while processing your request. ERROR: ' + thrownError;
                showMessageBox(output_msg, 'Error saving information', "error");
            }
            toggleSubmitButton(false);
            toggleLoadingImage(false);
        }
    });
    
}

function hideStep1(hideButton) {
    console.log(phoneIti.getNumber("E164" + intlTelInputUtils.numberFormat.E164));
    console.log(phoneIti.getNumber("INTERNATIONAL" + intlTelInputUtils.numberFormat.INTERNATIONAL));
    console.log(phoneIti.getNumber("NATIONAL" + intlTelInputUtils.numberFormat.NATIONAL));
    console.log(phoneIti.getNumber("RFC3966" + intlTelInputUtils.numberFormat.RFC3966));

    $(hideButton).addClass("hidden");
    $('#GeneralCompanyInfo').addClass("hidden");
    $('#step1Banner').addClass("hidden");
    $('#step1').removeClass("selected");
}

function hideStep2(hideButton) {
    $(hideButton).addClass("hidden");
    $('#step2').removeClass("selected");
    $('#LocationContactInformation').addClass("hidden");
    $('#step2Banner').addClass("hidden");
    $('#step2Banner1').addClass("hidden");
    $('#step2Banner2').addClass("hidden");
    $('#step2Banner3').addClass("hidden");
    $('#step2Banner4').addClass("hidden");
}

function hideStep3(hideButton) {
    $(hideButton).addClass("hidden");
    $('#step3').removeClass("selected");
    $('#RemitInformation').addClass("hidden");
    $('#step3Banner').addClass("hidden");
    $('#step3Banner1').addClass("hidden");
    $('#step3Banner2').addClass("hidden");
    $('#step3Banner3').addClass("hidden");
}

function hideStep4(hideButton) {
    $(hideButton).addClass("hidden");
    $('#step4').removeClass("selected");
    $('#SupplierPaymentInfo').addClass("hidden");
    $('#step4Banner').addClass("hidden");
    $('#step4Banner1').addClass("hidden");
    $('#step4Banner2').addClass("hidden");
    $('#step4Banner3').addClass("hidden");
}

function hideStep5(hideButton) {
    $(hideButton).addClass("hidden");
    $('#step5').removeClass("selected");
    $('#BusinessCategory').addClass("hidden");
    $('#step5Banner').addClass("hidden");
    $('#step5Banner1').addClass("hidden");
    $('#step5Banner2').addClass("hidden");
}

function hideStep6(hideButton) {
    $(hideButton).addClass("hidden");
    $('#step6').removeClass("selected");
    $('#UploadDocsSubmit').addClass("hidden");
    $('#step6Banner').addClass("hidden");
    $('#step6Banner1').addClass("hidden");
    $('#step6Banner2').addClass("hidden");
}

function hideStep7() {
    $('#FinalVerification').addClass("hidden");
    $('#step7').removeClass("selected");
    $('#step7Banner').addClass("hidden");
    $('#step7Banner1').addClass("hidden");
    $('#step7Banner2').addClass("hidden");
}

function showStep1(showButton) {
    $(showButton).removeClass("hidden");
    $('#step1').addClass("selected");
    $('#GeneralCompanyInfo').removeClass("hidden");
    $('#step1Banner').removeClass("hidden");
}

function showStep2(showButton) {
    $(showButton).removeClass("hidden");
    $('#step2').addClass("selected");
    $('#step2Banner').removeClass("hidden");
    $('#step2Banner1').removeClass("hidden");
    $('#step2Banner2').removeClass("hidden");
    $('#step2Banner3').removeClass("hidden");
    $('#step2Banner4').removeClass("hidden");
    $('#LocationContactInformation').removeClass("hidden");
}

function showStep3(showButton) {
    $(showButton).removeClass("hidden");
    $('#step3').addClass("selected");
    $('#step3Banner').removeClass("hidden");
    $('#step3Banner1').removeClass("hidden");
    $('#step3Banner2').removeClass("hidden");
    $('#step3Banner3').removeClass("hidden");
    $('#RemitInformation').removeClass("hidden");
}

function showStep4(showButton) {
    $(showButton).removeClass("hidden");
    $('#step4').addClass("selected");
    $('#step4Banner').removeClass("hidden");
    $('#step4Banner1').removeClass("hidden");
    $('#step4Banner2').removeClass("hidden");
    $('#step4Banner3').removeClass("hidden");
    $('#SupplierPaymentInfo').removeClass("hidden");
}

function showStep5(showButton) {
    $(showButton).removeClass("hidden");
    $('#step5').addClass("selected");
    $('#step5Banner').removeClass("hidden");
    $('#step5Banner1').removeClass("hidden");
    $('#step5Banner2').removeClass("hidden");
    $('#BusinessCategory').removeClass("hidden");
}

function showStep6(showButton) {
    $(showButton).removeClass("hidden");
    $('#step6').addClass("selected");
    $('#UploadDocsSubmit').removeClass("hidden");
    $('#step6Banner').removeClass("hidden");
    $('#step6Banner1').removeClass("hidden");
    $('#step6Banner2').removeClass("hidden");
}

function showStep7() {
    $('#FinalVerification').removeClass("hidden");
    $('#step7').addClass("selected");
    $('#step7Banner').removeClass("hidden");
    $('#step7Banner1').removeClass("hidden");
    $('#step7Banner2').removeClass("hidden");
}
